// https://www.youtube.com/watch?v=YeSzQzfcQCs

<template >
    <div class="main-cont container">
      <div class="title">
        <!-- Choose Category -->
        <div v-if="!categoryChosen || this.$route.path == '/users/items-controller'">
            <SelectCategory/>
        </div>
        <div v-else>
          <div class="nav-buttons">
            <a v-if="$route.name == 'Items'" class="nav-button" @click="backToCategories()"><span class="icon icon-reply"></span> Back To Categories</a>
            <router-link v-else class="nav-button" :to="'/users/items-controller/items?type=' +getType()"><span class="icon icon-reply"></span> Back To List</router-link>
            <div v-if="$route.name !== 'Add Part' && $route.name !== 'Edit Part'" style="display: inline-block">
              <router-link class="nav-button" @click="option.action()" :to="option.url+ '?type='+getType()" v-for="(option, index) in menu" :key="index"> 
                <span class="icon icon-add-to-list"></span> Add {{getCurrentPartType || 'New'}}
              </router-link>
            </div>           
          </div>
        <router-view></router-view>
        </div>
      </div>
    </div>
</template>

<script>
import { EventBus }       from '../../eventBus'
import { mapGetters, mapActions }     from 'vuex';
import SelectCategory     from './SelectCategory.vue'

export default {
  name: 'Items Controller',
  components:{
    SelectCategory,
  },
  watch: { 
    attribs: function() { // watch it
    },
    asin: function(newVal) { // watch it
    console.log(newVal)
    },
  },
  data() {
    return {
      status: 'Paste a product link and press fetch to get started...',
      forms: {},
      autoFillMode: true,
      attribs: {
        general: {
        },
        specifications:[],
        compats: [],
      },
       categoryChosen: false,
       category: '',
       message: '',
       menu: [
         {
            name: 'Add '+this.getCurrentPartType,
            url: '/users/items-controller/addpart'
         },
       ]
    }
  },
  computed: 
    mapGetters([
      'getAttribs',
      'allProcessors',
      'allMotherboards',
      'allRam',
      'allStorage',
      'allGpus',
      'allPsus',
      'allCases',
      'allAccessories',
      'getCurrentPartType',
      
  ]),
  mounted() {
    this.categoryChosen = false
    this.itemsLoaded(false)
    EventBus.$on('chooseCategory', (category) => {
      this.fetchItems()
      this.categoryChosen = true;
      this.category = category.toLowerCase();
      switch(category.toLowerCase()) {
          case 'cpu':
              console.log('processors assigned')
              this.forms = this.allProcessors
          break;
          case 'motherboard':
              console.log('motherboards assigned')
              this.forms = this.allMotherboards
          break;
          case 'ram':
              console.log('RAM assigned')
              this.forms = this.allRam
          break;
          case 'storage':
              console.log('Storage assigned')
              this.forms = this.allStorage
          break;
          case 'graphics':
              console.log('Graphics assigned')
              this.forms = this.allGpus
          break;
          case 'psu':
              console.log('PSU assigned')
              this.forms = this.allPsus
          break;
          case 'case':
              console.log('Case assigned')
              this.forms = this.allCases
          break;
          case 'accessories':
              console.log('Accessories assigned')
              this.forms = this.allAccessories
          break;
          default:
      }
    });
  },
  methods: {
    ...mapActions([
      'setPartAttribs',
      'setCurrentPartType',
      'fetchItems',
      'unsetItem',
      'itemsLoaded'
    ]),
    backToCategories(){
      this.itemsLoaded(false)
      this.categoryChosen = false
      this.category = '';
      this.forms = {}
      // this.setCurrentPartType('')
      let query = Object.assign({}, this.$route.query);
      if(query.type) {
        delete query.type;
        this.$router.replace({ query });
      }
      this.unsetItem()
    },
    autoFill(attribs, value){
      //General
      for(var i = 0; i<attribs.general.length; i++){
        attribs.general[i] = value;
      }
      //Specifications
      for(var j = 0; j<attribs.specifications.length; j++){
        attribs.specifications[j] = value;
      }
      //Compatibility
      for(var k = 0; k<attribs.compats.length; k++){
        attribs.compats[k] = value;
      }
      this.message = 'Auto Filled'
    },
    getType(){
      return this.$route.query.type
    },
    showAsin(){
      console.log(this.attribs.general[0])
    },
    print(index){
      return console.log(Object.values(this.settings.options)[index])
    },
  },
}
</script>

<style scoped>
@import '../../assets/css/custom.css';
@import '../../assets/css/dashboard.css';
@import '../../assets/css/toolkit-inverse.css';

.cat-opt{
  padding-top: 20px;
}
.nav-buttons {
  border-bottom: 1px solid #434857;
  padding-bottom: 3px;

}
.nav-button {
  margin: 5px 3px;
  padding: 3px 5px;
  margin-top: 0px;
  margin-left: 0px;
  padding-bottom: 0px;
  text-decoration: none;
  color: #cfd2da;
  display: inline-block !important;
  border-radius: 6px;
  cursor: pointer;
}
.nav-button:hover {
  opacity: 0.8;
}
.nav-button a {
  display: inline !important;
}
h4 {
  text-transform: capitalize !important;
  padding: 10px;
  padding-left: 0px;
  color: #1997c6 !important;
}
p {
  color: #B2B3B4
}
.testing-button {
  text-transform: uppercase;
  margin-top: 0px;
}
.label {
  border-bottom: 1px solid #9198aa;
  margin-bottom: 14px;
}
.label h4{
  height: 33px;
  font-size: 15pt;
  font-weight: normal;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.main-cont label{
  color: #B2B3B4;
  text-transform: uppercase;
}
.form-control{
  margin-bottom: 10px;
}
.item-list ul:hover {
  background-color: #434857;
}
.form {
  margin-top: 15px;
  padding-left: 14px;
  padding-right: 20px !important;
  /* max-height: 505px !important; */
  overflow-y: scroll;
  display: inline-block;
  width: 100%;
}
.top-block {
  height: 140px;
  padding-right: 14px;
  border-right: 1px solid #9198aa;
  padding-left: 14px;
  width: 70%;
  vertical-align: top;
  display: inline-block !important;
}
.no-r-border {
  border-right: none;
  padding-right: 0px;
  width: 30%;
}
.url-input {
  border:0px;
  width: 100%;
  display: inline-block;
}
.btn-fetch {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  height: 33px;
  margin-left: 2px;
  width: 80px;
}
.desktop-right{
  display: inline-block;
  width:48%;
  border: 1px solid white;
}
.footer {
  position: absolute;
  bottom: 0px;
}
</style>